import { useFormik } from 'formik'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { createAdd } from '../../actions/advertisingActions'
import { createJob } from '../../actions/jobsAxctions'
import CreateAdvertisingView from '../../containers/Advertising/CreateAdvertising/CreateAdvertising'

const CreateAdvertising = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const formik = useFormik({
    initialValues:{
      url:"",
      advertisingType:"",


    },
    onSubmit:(values)=>{
      const formData = new FormData()
      formData.append("url",values.url)
      formData.append("advertisingType",values.advertisingType)
      formData.append("image",values.image)

      dispatch(createAdd(formData,history))
    }
    

  })
  return (
    <CreateAdvertisingView formik={formik}/>
  )
}

export default CreateAdvertising